import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
 

@Injectable({
  providedIn: 'root'
})
export class TaxPayerService extends BaseService{

  getByTelephone(telephone: string) {
    return this.http.get(this.sharedService.apiUrl('taxpayer/byTelephone/' + encodeURIComponent(telephone)));
  }

}
